/* eslint-disable @typescript-eslint/no-explicit-any */
import { axiosInstances, getAxiosHeaders } from '@api/config/axios';
import { routes } from '@api/config/routes';
import { getProfile } from '@api/form-verification';
import { safeLocalStorageGetItem } from '@global/helpers/general';
import { mixpanel } from '@global/monitoring/mixpanel/index';
import { login, logout } from '@redux/slices/auth';
import { store } from '@redux/store';
import axios from 'axios';

export const signin = async (mobile: string) => {
  try {
    const res = await axiosInstances.webWallet?.post(
      routes.profile.login,
      { mobile },
      getAxiosHeaders()
    );
    return res?.data;
  } catch (e: any) {
    return e?.response?.data;
  }
};

export const updateMobile = async (mobile: string) => {
  try {
    const res = await axiosInstances.webWallet?.post(
      routes.profile.updateMobile,
      { mobile },
      getAxiosHeaders()
    );
    return res?.data;
  } catch (e: any) {
    return e?.response?.data;
  }
};

export const createWallet = async (name: string, mobile: string) => {
  try {
    const res = await axiosInstances.webWallet?.post(
      routes.profile.base,
      {
        mobile,
        name
      },
      getAxiosHeaders()
    );
    return res?.data;
  } catch (error) {
    console.info(error);
  }
};

export const validateOtp = async (txnId: string, otp: string) => {
  try {
    const res = await axiosInstances.webWallet?.put(
      routes.profile.verifyOtpByTxnId(txnId),
      { otp },
      getAxiosHeaders()
    );
    return res?.data;
  } catch (err) {
    console.info(err);
  }
};

export const generateLoginTokenFromRefreshToken = async (refreshToken: string) => {
  try {
    const response = await axiosInstances.webWallet?.put(
      routes.profile.getToken,
      {},
      {
        headers: {
          Authorization: `Bearer ${refreshToken}`
        }
      }
    );
    if (response?.data?.code === 0) {
      const profile = await getProfile(response?.data?.data?.accessToken);
      mixpanel.identify(profile?.data?.mobile);
      store.dispatch(login({ ...response?.data?.data }));
    }
    return response;
  } catch {
    store.dispatch(logout());
  }
};

export const refreshAccessTokenAtRegularInterval = async () => {
  window.intervalId = 0;
  try {
    const refreshTokenExpiresIn = safeLocalStorageGetItem('refreshTokenExpiresIn') ?? 3600;
    window.intervalId = +setInterval(
      async () => {
        const refreshToken = safeLocalStorageGetItem('refreshToken');
        if (refreshToken) {
          await generateLoginTokenFromRefreshToken(refreshToken);
        }
      },
      (Number(refreshTokenExpiresIn) - 60) * 1000
    );
  } catch (e) {
    console.error(e);
  }
};

export const startRefreshAccessTokenAtRegularInterval = async (rToken?: string) => {
  try {
    const refreshToken = rToken || safeLocalStorageGetItem('refreshToken');
    if (refreshToken) {
      const res = await generateLoginTokenFromRefreshToken(refreshToken);
      if (res?.data?.data?.accessToken) {
        // await decodeAccessTokenAndCheckIfItIsAllowed(res.data.access_token)
        refreshAccessTokenAtRegularInterval();
        return res?.data?.data?.accessToken;
      }
    } else {
      store.dispatch(logout());
      return null;
    }
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const getCountryNameCode = async () => {
  return axios
    .get(import.meta.env.VITE_GEO_LOCATION_API)
    .then((res) => {
      return res.data;
    })
    .catch(() => {
      // console.log(e);
      return false;
    });
};
